// All subscription pricing in one place.
// Update this file when prices change — all UI components read from here.

export const pricing = {
  individual: {
    plus: {
      monthly: 20,
      yearly: 144,
    },
    pro: {
      monthly: 50,
      yearly: 360,
    },
  },
  team: {
    plus: {
      monthly: 30,
      yearly: 200,
    },
    pro: {
      monthly: 60,
      yearly: 432,
    },
  },
  // Special offer (banana promo) — standalone pricing
  specialOffer: {
    yearly: 99,
    originalYearly: 240,
    savings: 141,
  },
} as const;

// Shared discount percentage for annual billing
export const discountPercent = 40;

export function yearlyMonthlyEquivalent(yearlyPrice: number): number {
  return Math.round(yearlyPrice / 12);
}

/** Format a Stripe price (in cents) into a human-readable label like "$10/month" or "$144/year" */
export function formatPriceLabel(
  priceInCents: number,
  interval: string | null,
): string {
  const dollars = (priceInCents / 100).toFixed(2).replace(/\.00$/, '');
  return `$${dollars}/${interval === 'year' ? 'year' : 'month'}`;
}
